module.exports = __webpack_public_path__ + "static/media/Heart.10a7f41b.png";